<template>
  <el-form
    @submit.native.prevent
    class="dsf-online-login-tab-plan"
    label-width="1.8rem"
    :disabled="disabled"
    :css-disabled="disabled"
  >
    <el-form-item label="用户名">
      <span slot="label">
        <i class="iconfont icon-person"></i>
        <span class="label-text">用户名</span>
      </span>
      <el-input
        v-model.trim="username"
        :disabled="loading"
        :placeholder="userNamePlaceholder"
        clearable
      >
      </el-input>
    </el-form-item>
    <el-form-item label="密   码">
      <span slot="label">
        <i class="iconfont icon-mine_xgmm"></i>
        <span class="label-text">密码</span>
      </span>
      <password-iframe-input
        :disabled="disabled"
        v-model.trim="password"
        :placeholder="passwordPlaceholder"
      />
    </el-form-item>
    <el-form-item label="验证码">
      <span slot="label">
        <i class="iconfont icon-anquan"></i>
        <span class="label-text">验证码</span>
      </span>
      <el-input
        class="input-qrcode"
        v-model.trim="qrCode"
        :disabled="loading"
        :placeholder="'请输入验证码'"
        clearable
      >
        <template slot="append">
          <img v-show="qrCodeImg" :src="qrCodeImg" @click="getQrCode" />
        </template>
      </el-input>
    </el-form-item>
    <el-button
      class="btn-wrap"
      :loading="loading"
      native-type="submit"
      @click="submit"
    >
      登录
    </el-button>
  </el-form>
</template>

<script>
import PasswordIframeInput from "../../components/passwordInput/passwordIframeInput.vue";
export default {
  name: "TabOnlineReport",
  components: {
    PasswordIframeInput,
  },
  props: {
    userNamePlaceholder: {
      type: String,
      default: "请输入统一社会信用代码",
    },
    passwordPlaceholder: {
      type: String,
      default: "请输入密码",
    },
    disabled: {
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      username: "",
      password: "",
      qrCodeImg: "",
      qrCodeId: "",
      qrCode: "",
      tongfangUser: "",
      investObjType: ''
    };
  },
  created() {
    this.getQrCode();
  },
  methods: {
    getQrCode() {
      dsf.http.get("/code/imageBase64").done(({ data, success }) => {
        if (success) {
          this.qrCodeImg = "data:image/png;base64," + data.imageBase64;
          this.qrCodeId = data.id;
          this.qrCode = "";
        }
      });
    },
    submit() {
      if (!dsf.config.setting_public_smpublickey) {
        return dsf.layer.message("没有获取到公钥", false);
      }
      this.username = _.trim(this.username);
      this.password = _.trim(this.password);
      this.qrCode = _.trim(this.qrCode);
      if (this.username === "") {
        dsf.layer.message("用户名不能为空！", false);
        return false;
      }
      if (this.password === "") {
        dsf.layer.message("密码不能为空！", false);
        return false;
      }
      if (this.qrCode === "") {
        dsf.layer.message("验证码不能为空！", false);
        return false;
      }
      this.loginNew();
    },
    tongFangLogin(isWindows, code) {
      let url = isWindows
        ? dsf.config.tongfang_window_url
        : dsf.config.tongfang_xc_url;
      $.ajax({
        type: "GET",
        url: url,
        crossDomain: true,
        cache: false,
        complete: (xhr, state) => {
          if (xhr.responseText === "") {
            if(this.investObjType === 1) {
              if (dsf.config.geer_login_url) {
                location.replace(dsf.config.geer_login_url + "?code=" + code);
              }
            } else {
              if (dsf.config.tongfang_login_url) {
                location.replace(dsf.config.tongfang_login_url + "?code=" + code);
              }
            }
          } else if (xhr.responseJSON && xhr.responseJSON.length > 0) {
            let data = false
            const findUser = (username) => {
              return _.find(
                xhr.responseJSON,
                (item) => item.OU?.length === 18 ? item.OU === username : item.OU === this.tongfangUser
              );
            };
            if (this.username.length === 18) {
              data = findUser(this.username);
            } else if (this.username.length > 18 && this.username.charAt(18) === '_') {
              this.tongfangUser = this.username.substring(0, 18);
              data = findUser(this.tongfangUser);
            }
            if (!data) {
              if ((this.username.length === 18 && !this.username.includes('_')) || 
                  (this.username.length > 18 && this.username.charAt(18) === '_')) {
                this.tongfangUser = this.username.substring(8, 17);
              } else {
                this.tongfangUser = this.username.split('_')[0];
              }
              data = findUser(this.tongfangUser);
            }
            this.loading = false;
            if (data) {
              if(this.investObjType === 1){
                if (dsf.config.geer_login_url) {
                location.replace(
                  dsf.config.geer_login_url + "?code=" + code
                );
              }
              } else {
                if (dsf.config.tongfang_login_url) {
                  location.replace(
                    dsf.config.tongfang_login_url + "?code=" + code
                  );
                }
              }
            } else {
              this.errorLocation();
            }
          } else {
            this.errorLocation();
          }
        },
      });
    },
    processAccount(account) {
      // 判断帐号长度是否大于18位
      if (account.length > 18) {
            // 截取前18位
            let shortenedAccount = account.substring(0, 18);
            // 判断帐号的第19位是否是下划线
            if (account.charAt(18) === '_') {
                // 判断截取的帐号是否存在
                if (!accountExists(shortenedAccount)) {
                    // 如果不存在，继续走原有逻辑
                    continueOriginalLogic(account);
                    return;
                }
            }
        }
        // 原有逻辑
      continueOriginalLogic(account);
    },
    errorLocation() {
      this.loading = false;
      if(this.investObjType === 1) {
        if (dsf.config.geer_cds) {
          location.replace(dsf.config.geer_cds);
        }
      } else {
        if (dsf.config.tongfang_cds) {
          location.replace(dsf.config.tongfang_cds);
        }
      }
    },
    // 专用
    validateFormatAccount(text) {
      const xcRegex = /^XC\d{12}$/;
      const xzRegex = /^XZ\d{9}$/;
      return xcRegex.test(text) || xzRegex.test(text);
    },
    loginNew() {
      this.investObjType = this.validateFormatAccount(this.username) ? 1 : 2
      this.loading = true;
      dsf.http
        .post("user/login/investObj/loginNew", {
          password: dsf.sm2.encode(
            this.password,
            dsf.config.setting_public_smpublickey
          ),
          userName: this.username,
          code: this.qrCode,
          codeId: this.qrCodeId,
          investObjType: this.investObjType
        })
        .then(({ data }) => {
          if (data.success) {
            dsf.cookies.set("loginUserName", this.username, {
              domain: "stats.gov.cn",
            });
            dsf.cookies.set("TJY_LWZB_TICKET_CODE", data.data.code, {
              domain: "stats.gov.cn",
            });
            this.tongFangLogin(dsf.client.Windows(), data.data.code);
          } else {
            dsf.layer.message(data.message, false);
            this.loading = false;
            this.getQrCode();
          }
        })
        .catch(() => {
          dsf.layer.message("服务器未知异常", false);
          this.loading = false;
          this.getQrCode();
        });
    },
  },
};
</script>
